import { render, staticRenderFns } from "./issuable_lock_form.vue?vue&type=template&id=6a8f6b72"
import script from "./issuable_lock_form.vue?vue&type=script&lang=js"
export * from "./issuable_lock_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports